import { useState } from "react";

interface FilterGroup {
  key: "regions" | "years" | "genres" | "tags";
  label: string;
  options: string[];
}

interface FilterBarProps {
  groups: FilterGroup[];
  selected: Record<string, string[]>;
  onToggle: (key: string, value: string) => void;
  onReset: () => void;
  activeCount: number;
}

function PillGroup({
  group,
  values,
  onToggle,
}: {
  group: FilterGroup;
  values: string[];
  onToggle: (key: string, value: string) => void;
}) {
  return (
    <div className="flex items-start gap-3 py-2.5 border-b border-background-200/70 last:border-b-0">
      <span className="shrink-0 w-12 pt-1.5 text-sm font-medium text-foreground-500">{group.label}</span>
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => values.forEach((v) => onToggle(group.key, v))}
          className={`px-3 py-1.5 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap ${
            values.length === 0
              ? "bg-primary-500 text-background-50"
              : "bg-background-100 text-foreground-700 hover:bg-background-200"
          }`}
        >
          全部
        </button>
        {group.options.map((opt) => {
          const active = values.includes(opt);
          return (
            <button
              key={opt}
              type="button"
              onClick={() => onToggle(group.key, opt)}
              className={`px-3 py-1.5 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap ${
                active
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function FilterBar({ groups, selected, onToggle, onReset, activeCount }: FilterBarProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="bg-background-50 border border-background-200/80 rounded-lg">
      <div className="md:hidden flex items-center justify-between px-4 py-3">
        <button
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
          className="flex items-center gap-2 text-sm font-medium text-foreground-800 cursor-pointer"
        >
          <i className="ri-filter-3-line" aria-hidden="true"></i>
          筛选条件
          {activeCount > 0 && (
            <span className="w-5 h-5 rounded-full bg-accent-500 text-primary-950 text-xs flex items-center justify-center">
              {activeCount}
            </span>
          )}
          <i className={mobileOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} aria-hidden="true"></i>
        </button>
        {activeCount > 0 && (
          <button type="button" onClick={onReset} className="text-sm text-primary-600 cursor-pointer">
            重置
          </button>
        )}
      </div>

      <div className={`${mobileOpen ? "block" : "hidden"} md:block px-4 pb-4 md:py-3`}>
        <div className="flex flex-col">
          {groups.map((group) => (
            <PillGroup key={group.key} group={group} values={selected[group.key] || []} onToggle={onToggle} />
          ))}
        </div>
        <div className="hidden md:flex justify-end pt-3">
          <button type="button" onClick={onReset} className="text-sm text-primary-600 cursor-pointer hover:text-primary-700">
            重置筛选
          </button>
        </div>
      </div>
    </div>
  );
}